import * as React from 'react';
export const IcCarFleet = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.79 7.34l-1.34-2.68A3 3 0 0016.76 3h-5.52a3 3 0 00-2.69 1.66L7.88 6h4.88a5 5 0 014.48 2.76l1.34 2.69c.274.557.418 1.17.42 1.79V15a1 1 0 002 0V8.24a2 2 0 00-.21-.9zm-5.34 2.32A3 3 0 0012.76 8H7.24a3 3 0 00-2.69 1.66l-1.34 2.68a2 2 0 00-.21.9V20a1 1 0 102 0v-1h10v1a1 1 0 002 0v-6.76a2 2 0 00-.21-.9l-1.34-2.68zm-9.11.89a1 1 0 01.9-.55h5.52a1 1 0 01.9.55L14.88 13H5.12l1.22-2.45zm.37 6.16a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 015 15.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02zm8 0a1 1 0 01-1.27.12.94.94 0 01-.36-.45 1 1 0 01-.08-.58 1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v.02z'
      fill='currentColor'
    />
  </svg>
);
